import { FC, useState, useEffect } from "react"
import { Select } from "antd"

import styles from "./XForm.module.scss"

type XSelectProps = {
  children: any
  width?: string
  selected?: string
  style?: any
  onChange: (s: string) => void
}

type XSelectOptionProps = {
  children: any
  value: string
}

type XSelectExtensions = {
  Option: typeof XSelectOption
}

export const XSelect: FC<XSelectProps> & XSelectExtensions = ({
  children, selected, onChange, width = "auto", style = {}
}) => {

  const [openned, setOpenned] = useState(false)
  const [options, setOptions] = useState([] as any[])

  useEffect(() => {
    if (children instanceof Array && children.length > 0 && children.length != options.length) {
      let opts: any[] = []
      children.forEach(child => {
        console.log(child)
        if (child instanceof Array && child.length > 0) {
          child.forEach(element => {
            opts.push({value: element.props.value, label: element.props.children})
          })
        } else {
          opts.push({value: child.props.value, label: child.props.children})
        }
      })
      console.log(opts)
      setOptions(opts)
    }
  }, [children])

  return (
    <>
      <Select
        defaultValue={selected}
        value={selected}
        style={{ width: width, ...style }}
        className={styles.xselect_inp}
        onChange={onChange}
        options={options}
      />
    </>
  )
}

const XSelectOption: FC<XSelectOptionProps> = ({
  children, value
}) => {
  return (
    <>
      <div className={styles.dropdown_item}>{children}</div>
    </>
  )
}

XSelect.Option = XSelectOption